export const summaryRows: string[] = [
  'Tomo 1 — Fundamentos del Petróleo y Gas',
  'Tomo 2 — Geología del Petróleo y Sistemas Petroleros',
  'Tomo 3 — Exploración de Petróleo y Gas',
  'Tomo 4 — Perforación y Construcción de Pozos',
  'Tomo 5 — Producción de Petróleo y Gas',
  'Tomo 6 — Refinación de Petróleo y Procesamiento de Gas Natural',
  'Tomo 7 — Transporte, Almacenamiento y Distribución de Petróleo y Gas',
  'Tomo 8 — Seguridad, Gestión de Riesgos y Medio Ambiente',
  'Tomo 9 — Enseñanza del Petróleo y Gas: Estrategias, Actividades y Proyectos Educativos 2026',
  'Bono 1 — 150 Actividades y Desafíos',
  'Bono 2 — Kit de Evaluación Completo',
  'Bono 3 — 100 Casos y Situaciones Problemáticas',
  'Bono 4 — Diccionario Docente de 200 Conceptos',
  'Bono 5 — 100 Preguntas y Temas de Debate',
  'Garantía de 7 días sin preguntas',
  'Acceso inmediato',
];
